import {
  PairedCostRouteItemWithQuery,
  isDefined,
  schAlertType,
  schPairedCostRouteItem,
  schQueryParams,
  syntaxFNMA,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getCompTypeLabel, getScopedAlertType } from '../utils/compTypeScoping.ts';

export const lessThanThreeSettledSales: AlertDefinition = ({
  compSequence,
  compType,
  propertyDataEntities,
}) => {
  const comps = compSequence
    .map((id) => propertyDataEntities[id])
    .filter(isDefined)
    .map((compData) => (compData as CompPropertyDataState).compData);

  const settledSales = comps.filter(
    (comp) =>
      comp.editableData.transaction.saleDate !== undefined &&
      comp.editableData.transaction.status === syntaxFNMA.schUadListingStatus.enum.SettledSale,
  );

  if (settledSales.length >= 3) return undefined;

  let message: string;
  switch (compType) {
    case 'aiv':
    case 'arv':
      message = `Fewer than 3 ${getCompTypeLabel(compType)} closed sales are included as Comparables.`;
      break;
    default:
      message = 'Fewer than 3 closed sales are included as Comparables.';
      break;
  }

  return {
    type: getScopedAlertType(schAlertType.enum.lessThanThreeSettledSales, compType),
    status: 'active',
    message,
    ...(compType ? { compType } : {}),
    fixingInfo: {
      tips: 'Tips: It is highly recommended that you expand your search geography in order to provided at least 3 comparable sales. If fewer than 3 closed sales are available, include a clear explanation of the limited market activity and what alternative data was considered to support the opinion of value.',
      pairedCostRouteItem:
        `${schPairedCostRouteItem.enum.features}?${schQueryParams.enum.addComps}=true` as PairedCostRouteItemWithQuery,
    },
  };
};
